import * as React from "react";
import { connect } from "react-redux";

import { Card, Grid, Menu, Tab, TabProps } from "semantic-ui-react";

import { Authorize } from "reauthorize";

import { ADMIN_ROLES } from "@teamprevent/common/auth/roles";

import { OrgStructure } from "../../orgStructure";
import { CustomerUserDetailModel, AppState } from "../model";
import { customerUserSelector, basePathSelector, routeIdSelector } from "../selectors";

import { loadCustomerUserDetail } from "../actions";

import * as details from "./details";
import ContextItems from "./details/ContextItems";

import { Link, push } from "redux-little-router";

export interface CoreDetailProps {
    customerUser: CustomerUserDetailModel;
    orgStructures: OrgStructure[];
}

export interface DetailProps extends CoreDetailProps {
    path: string;
    basePath: string;
    tab?: string;
    customerUserId: string;
}

export interface DispatchProps {
    push: (path: string) => void;
    getCustomerUserDetails: (id: string) => void;
}

const tabs = (Object.keys(details) as (keyof typeof details)[]).map(k => details[k]);

export class Detail extends React.Component<DetailProps & DispatchProps> {
    constructor(props: DetailProps & DispatchProps) {
        super(props);
        this.handleTabChange = this.handleTabChange.bind(this);
        props.getCustomerUserDetails(props.customerUserId);
    }

    public render() {
        const panes = tabs.map(t => t(this.props));
        const activeIndex = panes.slice(1).findIndex(p => this.props.tab && this.props.tab.startsWith(p.path)) + 1;

        const content = () => panes.length === 1
            ? <Card fluid>{panes[0].render()}</Card>
            : <Tab panes={panes} onTabChange={this.handleTabChange} activeIndex={activeIndex} />;

        return (
            <Grid container className="nomargintop">
                <Grid.Row>
                    <Grid.Column>
                        <h1>{this.props.customerUser.firstName}</h1>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={3} as={Grid} padded>
                        <Grid.Column vertical as={Menu}>
                            <Menu.Item name="CustomerUsers" as={Link} href={this.props.basePath}>
                                All Customer Users
                            </Menu.Item>
                            <Authorize authorize={[ADMIN_ROLES.SYSTEM_ADMIN.name]}>
                                <Menu.Item name="CustomerUserAuditLog" as={Link} href={`${this.props.basePath}/${this.props.customerUser.id}/auditLog`}>
                                    Customer User Audit
                                </Menu.Item>
                            </Authorize>
                            <ContextItems customerUser={this.props.customerUser} orgStructures={this.props.orgStructures} />
                        </Grid.Column>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        {content()}
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }

    private handleTabChange(event: any, { activeIndex }: TabProps) {
        this.props.push(`${this.props.basePath}/${this.props.customerUser.id}${tabs[activeIndex as unknown as number](undefined).path}`);
    }
}

const currentTab = (state: AppState) => state.router.pathname?.substring(
    basePathSelector(state).length + 1 + routeIdSelector(state).toString().length);

function mapStateToProps(state: AppState): DetailProps {
    return {
        customerUser: customerUserSelector(state),
        orgStructures: state.orgStructures,
        path: state.router.pathname,
        basePath: basePathSelector(state),
        tab: currentTab(state),
        customerUserId: routeIdSelector(state)
    };
}

function mapDispatchToProps(dispatch: any): DispatchProps {
    return {
        push: (path: string) => dispatch(push(path, {})),
        getCustomerUserDetails: (id: string) => dispatch(loadCustomerUserDetail({ customerUserId: id }))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Detail);
